import { Component, Input, OnInit } from '@angular/core';
import { ZtIcon } from './zt-icon.model';

@Component({
    selector: 'zt-icon',
    templateUrl: 'zt-icon.component.html',
    styleUrls: ['zt-icon.component.scss'],
})
export class ZtIconComponent implements OnInit {
    @Input() icon: ZtIcon | undefined;

    constructor() {}

    ngOnInit() {}

    get ZtIcon(): typeof ZtIcon {
        return ZtIcon;
    }
}
